import React, { useState, useEffect, useRef } from 'react';



// --- India State/District lists for typeahead (Present) ---
const INDIAN_STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana",
  "Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur",
  "Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana",
  "Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands","Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu","Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"
];

const STATE_DISTRICTS = {
  "Andhra Pradesh": ["Anantapur","Chittoor","East Godavari","Guntur","Krishna","Kurnool","Nellore","Prakasam","Srikakulam","Visakhapatnam","Vizianagaram","West Godavari","YSR Kadapa"],
  "Telangana": ["Adilabad","Bhadradri Kothagudem","Hyderabad","Jagtial","Jangaon","Jayashankar Bhupalpally","Jogulamba Gadwal","Kamareddy","Karimnagar","Khammam","Komaram Bheem","Mahabubabad","Mahabubnagar","Mancherial","Medak","Medchal–Malkajgiri","Mulugu","Nagarkurnool","Nalgonda","Narayanpet","Nirmal","Nizamabad","Peddapalli","Rajanna Sircilla","Ranga Reddy","Sangareddy","Siddipet","Suryapet","Vikarabad","Wanaparthy","Warangal Rural","Warangal Urban","Yadadri Bhuvanagiri"],
  "Karnataka": ["Bagalkot","Ballari","Belagavi","Bengaluru Rural","Bengaluru Urban","Bidar","Chamarajanagar","Chikkaballapur","Chikkamagaluru","Chitradurga","Dakshina Kannada","Davangere","Dharwad","Gadag","Hassan","Haveri","Kalaburagi","Kodagu","Kolar","Koppal","Mandya","Mysuru","Raichur","Ramanagara","Shivamogga","Tumakuru","Udupi","Uttara Kannada","Vijayapura","Yadgir"],
  "Tamil Nadu": ["Chennai","Coimbatore","Cuddalore","Dharmapuri","Dindigul","Erode","Kanchipuram","Kanniyakumari","Karur","Krishnagiri","Madurai","Nagapattinam","Namakkal","Nilgiris","Perambalur","Pudukkottai","Ramanathapuram","Salem","Sivaganga","Thanjavur","Theni","Thiruvallur","Thiruvarur","Thoothukudi","Tiruchirappalli","Tirunelveli","Tiruppur","Tiruvannamalai","Vellore","Viluppuram","Virudhunagar"],
  "Maharashtra": ["Ahmednagar","Akola","Amravati","Aurangabad","Beed","Bhandara","Buldhana","Chandrapur","Dhule","Gadchiroli","Gondia","Hingoli","Jalgaon","Jalna","Kolhapur","Latur","Mumbai City","Mumbai Suburban","Nagpur","Nanded","Nandurbar","Nashik","Osmanabad","Palghar","Parbhani","Pune","Raigad","Ratnagiri","Sangli","Satara","Sindhudurg","Solapur","Thane","Wardha","Washim","Yavatmal"],
  "Kerala": ["Alappuzha","Ernakulam","Idukki","Kannur","Kasaragod","Kollam","Kottayam","Kozhikode","Malappuram","Palakkad","Pathanamthitta","Thiruvananthapuram","Thrissur","Wayanad"],
  "Delhi": ["Central Delhi","East Delhi","New Delhi","North Delhi","North East Delhi","North West Delhi","Shahdara","South Delhi","South East Delhi","South West Delhi","West Delhi"],
  "Uttar Pradesh": ["Agra","Aligarh","Allahabad","Ambedkar Nagar","Amethi","Amroha","Auraiya","Azamgarh","Baghpat","Bahraich","Ballia","Balrampur","Banda","Barabanki","Bareilly","Basti","Bhadohi","Bijnor","Budaun","Bulandshahr","Chandauli","Chitrakoot","Deoria","Etah","Etawah","Ayodhya","Farrukhabad","Fatehpur","Firozabad","Gautam Buddha Nagar","Ghaziabad","Ghazipur","Gonda","Gorakhpur","Hamirpur","Hapur","Hardoi","Hathras","Jalaun","Jaunpur","Jhansi","Kannauj","Kanpur Dehat","Kanpur Nagar","Kasganj","Kaushambi","Kheri","Kushinagar","Lalitpur","Lucknow","Maharajganj","Mahoba","Mainpuri","Mathura","Mau","Meerut","Mirzapur","Moradabad","Muzaffarnagar","Pilibhit","Pratapgarh","Prayagraj","Rae Bareli","Rampur","Saharanpur","Sambhal","Sant Kabir Nagar","Sant Ravidas Nagar","Shahjahanpur","Shamli","Shrawasti","Siddharthnagar","Sitapur","Sonbhadra","Sultanpur","Unnao","Varanasi"],
  "West Bengal": ["Alipurduar","Bankura","Birbhum","Cooch Behar","Dakshin Dinajpur","Darjeeling","Hooghly","Howrah","Jalpaiguri","Jhargram","Kalimpong","Kolkata","Malda","Murshidabad","Nadia","North 24 Parganas","Paschim Bardhaman","Paschim Medinipur","Purba Bardhaman","Purba Medinipur","Purulia","South 24 Parganas","Uttar Dinajpur"]
};
const PresentAddress = ({ formData, errors, handleChange, handleBlur, nextStep, prevStep }) => {
  const [sameAsPermanent, setSameAsPermanent] = useState(false);
  const initialMount = useRef(true);
  

  // Effect to handle checkbox state changes
  useEffect(() => {
    if (sameAsPermanent) {
      // Copy permanent address data to present address
      const addressFields = [
        'Address', 'Street', 'Landmark', 'Village',
        'Mandal', 'District', 'State', 'Pincode'
      ];

      addressFields.forEach(field => {
        const permanentField = `permanent${field}`;
        const presentField = `present${field}`;

        if (formData[permanentField]) {
          // Create a synthetic event to update the form data
          const syntheticEvent = {
            target: {
              name: presentField,
              value: formData[permanentField]
            }
          };
          handleChange(syntheticEvent);
        }
      });
    }
  }, [sameAsPermanent, formData, handleChange]);

  const handleCheckboxChange = (e) => {
    setSameAsPermanent(e.target.checked);
  };

  return (
    <div>

      <div className="form-card-header mb-4">
        <h3 className="text-center">Present Address</h3>
      </div>
      <hr></hr>

      {/* Same as Permanent Address Checkbox */}
      <div className="row mb-4" style={{maxWidth:"50%"}}>
        <div className="col-12" >
          <div className="form-check" >
            <input
              className="form-check-input"
              type="checkbox"
              id="sameAsPermanent"
              checked={sameAsPermanent}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label" htmlFor="sameAsPermanent">
              Same as Permanent Address
            </label>
          </div>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-6">
          <label htmlFor="presentAddress" className="form-label">Address / D.No<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentAddress ? 'is-invalid' : ''}`}
            id="presentAddress"
            name="presentAddress"
            value={formData.presentAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          {errors.presentAddress && <div className="invalid-feedback">{errors.presentAddress}</div>}
        </div>

        <div className="col-md-6">
          <label htmlFor="presentStreet" className="form-label">Street Name <span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentStreet ? 'is-invalid' : ''}`}
            id="presentStreet"
            name="presentStreet"
            value={formData.presentStreet}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          {errors.presentStreet && <div className="invalid-feedback">{errors.presentStreet}</div>}
        </div>

        <div className="col-md-6">
          <label htmlFor="presentLandmark" className="form-label">Land Mark</label>
          <input
            type="text"
            className="form-control"
            id="presentLandmark"
            name="presentLandmark"
            value={formData.presentLandmark}
            onChange={handleChange}
            disabled={sameAsPermanent}
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="presentVillage" className="form-label">Village / Town<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentVillage ? 'is-invalid' : ''}`}
            id="presentVillage"
            name="presentVillage"
            value={formData.presentVillage}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          {errors.presentVillage && <div className="invalid-feedback">{errors.presentVillage}</div>}
        </div>

        <div className="col-md-6">
          <label htmlFor="presentMandal" className="form-label">Mandal<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentMandal ? 'is-invalid' : ''}`}
            id="presentMandal"
            name="presentMandal"
            value={formData.presentMandal}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          {errors.presentMandal && <div className="invalid-feedback">{errors.presentMandal}</div>}
        </div>

        

        <div className="col-md-6">
          <label htmlFor="presentState" className="form-label">State<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentState ? 'is-invalid' : ''}`}
            id="presentState"
            name="presentState" list="presentStatesList"
            value={formData.presentState}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          <datalist id="presentStatesList">
            {INDIAN_STATES.map((s) => (<option key={s} value={s} />))}
          </datalist>
          {errors.presentState && <div className="invalid-feedback">{errors.presentState}</div>}
        </div>

        <div className="col-md-6">
          <label htmlFor="presentDistrict" className="form-label">District<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentDistrict ? 'is-invalid' : ''}`}
            id="presentDistrict"
            name="presentDistrict" list="presentDistrictsList"
            value={formData.presentDistrict}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={sameAsPermanent}
          />
          <datalist id="presentDistrictsList">
            {(STATE_DISTRICTS[formData.presentState] || []).map((d) => (<option key={d} value={d} />))}
          </datalist>
          {errors.presentDistrict && <div className="invalid-feedback">{errors.presentDistrict}</div>}
        </div>

        <div className="col-md-6">
          <label htmlFor="presentPincode" className="form-label">Pin Code<span className="star">*</span></label>
          <input
            type="text"
            className={`form-control ${errors.presentPincode ? 'is-invalid' : ''}`}
            id="presentPincode"
            name="presentPincode"
            value={formData.presentPincode}
            onChange={(e) => {
              if (/^\d{0,6}$/.test(e.target.value)) {
                handleChange(e);
              }
            }}
            onBlur={handleBlur}
            maxLength={6}
            disabled={sameAsPermanent}
          />
          {errors.presentPincode && <div className="invalid-feedback">{errors.presentPincode}</div>}
        </div>

        {/* <div className="col-12 mt-4">
          <button type="button" className="btn btn-primary float-end" onClick={nextStep}>
            Next <i className="bi bi-arrow-right"></i>
          </button>
          <button type="button" className="btn btn-secondary me-2" onClick={prevStep}>
            <i className="bi bi-arrow-left"></i> Previous
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default PresentAddress;